import React from 'react'
import { BoxWrapper } from './ElementsStyles'

export default function InfoBox({ content }: any) {
  return (
    <BoxWrapper>
      <p className='title'>{content.title}</p>
      <p className='content'>{content.content}</p>
    </BoxWrapper>
  )
}
